import Vue from 'vue'
import Router from 'vue-router'
import store from './store/index'
//获取Token侧边菜单权限与每个页面的权限
import { getToken, getMenu, getPermission, removeToken, removeMenu, removePermission } from "./cookie/cookie";
import Layout from '@/views/dashboard/components/Layout'
import cloudMonitorLayout from '@/views/CloundMonitor/dashboard/Layout'
import contList from '@/views/dashboard/components/conlist'
import { getuser_iscustomer, getuser_ctid } from '@/localStorage/localStorage'
//路由跳转报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        //进入页面重定向至登录页面
        { path: '/', redirect: 'login' },
        {
            path: '/login',
            name: 'Login',
            component: (resolve) => require(['@/views/login/index'], resolve),
            meta: { title: '物联网云平台登录' }
        },
        //gateone连接
        {
            path: '/gateone/:id/:sn',
            name: 'Gateone',
            component: (resolve) => require(['@/views/gateone/index'], resolve),
            meta: { title: '远程操作', requiresAuth: true, Permission: 90 }
        },
        // webssh弹出
        {
            path: '/terminal/webssh/:id/:sn',
            name: 'Webssh',
            component: (resolve) => require(['@/views/device/components/components/webssh'], resolve),
            meta: { title: '远程终端', requiresAuth: true, Permission: 90 }
        },
        // web Page
        {
            name: 'webPage',
            path: '/web/:id/:sn',
            component: (resolve) => require(['@/views/deviceWeb/index'], resolve),
            meta: { title: '远程终端', requiresAuth: true, }
        },
        // 日志管理
        {
            path: '/logManagement',
            component: Layout,
            name: 'logManagement',
            children: [{
                path: '',
                name: 'logManagement',
                path: '/logManagement',
                component: (resolve) => require(['@/views/logManagement/index'], resolve),
                meta: { title: '日志管理', requiresAuth: true, Permission: 289 }
            }]
        },
        {
            name: '404',
            path: '/404',
            component: () =>
                import('@/components/404')
        },
        {
            path: '*',
            redirect: '/404'
        },
        // 设备管理路由
        {
            path: '/device',
            component: Layout,
            name: 'Device',
            meta: { title: '设备管理', requiresAuth: true },
            children: [{
                path: 'particulars/:id/:did',
                name: 'Particulars',
                component: () =>
                    import('@/views/device/components/particulars'),
                meta: { title: '设备详情', requiresAuth: true, Permission: 53, keepAlive: true }
            },
            {
                path: 'devicelist',
                name: 'DeviceList',
                component: () =>
                    import('@/views/device/DeviceList/index'),
                meta: { title: '设备列表', requiresAuth: true, sonId: 14, keepAlive: true }
            },
            {
                path: 'unusuallist',
                name: 'Unusuallist',
                component: () =>
                    import('@/views/device/UnusualList/index'),
                meta: { title: '异常设备列表', requiresAuth: true, sonId: 92 }
            },
            {
                path: 'groupinglist',
                name: 'GroupingList',
                component: () =>
                    import('@/views/device/GroupingList/index'),
                meta: { title: '分组列表', requiresAuth: true, sonId: 10, keepAlive: true }
            },
            {
                path: 'hangingDevice',
                name: 'HangingDevice',
                component: () =>
                    import('@/views/device/HangingDevice/index'),
                meta: { title: '打印机列表', requiresAuth: true, sonId: 198, keepAlive: true }
            },
            {
                path: 'terminalList',
                name: 'TerminalList',
                component: () =>
                    import('@/views/device/TerminalList/index'),
                meta: { title: '终端列表', requiresAuth: true, sonId: 276, keepAlive: true }
            }
            ]
        },
        // 故障管理路由
        {
            path: '/alarmMsg',
            component: Layout,
            name: 'AlarmMsg',
            meta: { title: '故障管理', requiresAuth: true },
            children: [{
                path: 'historywarn',
                name: 'Historywarn',
                component: () =>
                    import('@/views/alarmMsg/historywarn'),
                meta: { title: '历史告警', requiresAuth: true, sonId: 31 }
            },
            {
                path: 'warnconfiguration',
                name: 'Warnconfiguration',
                component: () =>
                    import('@/views/alarmMsg/warnconfiguration'),
                meta: { title: '告警配置', requiresAuth: true, sonId: 32 }
            },
            {
                path: 'currenttimewarn',
                name: 'Currenttimewarn',
                component: () =>
                    import('@/views/alarmMsg/currenttimewarn'),
                meta: { title: '实时报警', requiresAuth: true, sonId: 33 }
            },
            ]
        },
        // 统计报表
        {
            path: '/graphs',
            component: Layout,
            name: 'Graphs',
            meta: { title: '统计报表', requiresAuth: true },
            children: [{
                path: 'onlinerate',
                name: 'Onlinerate',
                component: () =>
                    import('@/views/graphs/onlinerate'),
                meta: { title: '在线率', requiresAuth: true, sonId: 80, keepAlive: true }
            },
            {
                path: 'flowstatistics',
                name: 'Flowstatistics',
                component: () =>
                    import('@/views/graphs/flowstatistics'),
                meta: { title: '流量统计', requiresAuth: true, sonId: 81, keepAlive: true }
            },
            {
                path: 'signalstatistics',
                name: 'Signalstatistics',
                component: () =>
                    import('@/views/graphs/signalstatistics'),
                meta: { title: '信号统计', requiresAuth: true, sonId: 82, keepAlive: true }
            },
            {
                path: 'softwareversion',
                name: 'Softwareversion',
                component: () =>
                    import('@/views/graphs/softwareversion'),
                meta: { title: '软件版本', requiresAuth: true, sonId: 83 }
            }
            ]
        },
        // 资源管理
        {
            path: '/resource',
            component: Layout,
            name: 'Resource',
            meta: { title: '配置管理', requiresAuth: true },
            children: [{
                path: 'configurationlist',
                name: 'Configurationlist',
                component: () =>
                    import('@/views/resource/ConfigurationList/index'),
                meta: { title: '设备配置', requiresAuth: true, sonId: 34, keepAlive: true }
            },
            {
                path: 'firmware',
                name: 'Firmware',
                component: () =>
                    import('@/views/resource/Firmware/index'),
                meta: { title: '批量配置', requiresAuth: true, sonId: 93 }
            },
            {
                path: 'configuration',
                name: 'Configuration',
                component: () =>
                    import('@/views/resource/ConfigUration/index'),
                meta: { title: '配置列表', requiresAuth: true, sonId: 7 }
            }
            ]
        },
        // 任务管理
        {
            path: '/task',
            component: Layout,
            name: 'Task',
            meta: { title: '软件管理', requiresAuth: true },
            children: [{
                path: 'upgrade',
                name: 'Upgrade',
                component: () =>
                    import('@/views/task/Upgrade/index'),
                meta: { title: '软件任务', requiresAuth: true, sonId: 77 }
            },
            {
                path: 'softwarepackage',
                name: 'Softwarepackage',
                component: () =>
                    import('@/views/task/SoftwarePackage/index'),
                meta: { title: '固件管理', requiresAuth: true, sonId: 76 }
            },
            {
                path: 'advertising',
                name: 'Advertising',
                component: () =>
                    import('@/views/task/advertising'),
                meta: { title: '广告', requiresAuth: true, sonId: 78 }
            }
            ]
        },
        // 系统管理
        {
            path: '/system',
            component: Layout,
            name: 'System',
            meta: { title: '系统管理', requiresAuth: true },
            children: [{
                path: 'authoritymanagement',
                name: 'Authoritymanagement',
                component: () =>
                    import('@/views/system/Authoritymanagement/index'),
                meta: { title: '安全管理', requiresAuth: true, sonId: 26, keepAlive: true }
            },
            {
                path: 'customermanagement',
                name: 'Customermanagement',
                component: () =>
                    import('@/views/system/customermanagement/index'),
                meta: { title: '客户管理', requiresAuth: true, sonId: 89, keepAlive: true }
            },
            {
                path: 'usercontrol',
                name: 'Usercontrol',
                component: () =>
                    import('@/views/system/usercontrol/index'),
                meta: { title: '用户管理', requiresAuth: true, sonId: 13, keepAlive: true }
            },
            {
                path: 'remoteservice',
                name: 'RemoteService',
                component: () =>
                    import('@/views/system/remoteservice/index'),
                meta: { title: '远程服务', requiresAuth: true, sonId: 174, keepAlive: true }
            },
            {
                path: 'parametermanagement',
                name: 'Parametermanagement',
                component: () =>
                    import('@/views/system/ParameterManagement/index'),
                meta: { title: '参数管理', requiresAuth: true, sonId: 167 }
            },
            {
                path: 'printerdriver',
                name: 'PrinterDriver',
                component: () => import('@/views/system/printerDriver/index'),
                meta: { title: '驱动管理', requiresAuth: true, sonId: 200, keepAlive: true }
            },
            ]
        },
        {
            path: '/dashboard',
            component: Layout,
            name: 'Dashboard',
            children: [{
                path: '',
                name: 'Index',
                component: () => import('@/views/dashboard/index'),
                meta: { title: '首页', requiresAuth: true, keepAlive: true }
            }]
        },
        /**
         * 云监测系统路由
         */
        {
            path: '/cloudMonitor',
            component: cloudMonitorLayout,
            children: [{
                path: 'cloudMonitorHome',
                name: 'MonitoringScreen',
                component: () => import('@/views/CloundMonitor/dashboard/index'),
                meta: { title: '监控大屏', requiresAuth: true, keepAlive: true }
            },
            // 设备管理
            {
                path: 'deviceManagement',
                meta: { title: '设备管理', requiresAuth: true, keepAlive: true },
                component: contList,
                children: [
                    {
                        path: 'fastAccess',
                        name: 'FastAccess',
                        component: () => import('@/views/CloundMonitor/fastAccess/index'),
                        meta: { title: '快速接入', sonId: 213, requiresAuth: true, keepAlive: true }
                    },
                    {
                        path: 'projectGroup',
                        name: 'ProjectGroup',
                        component: () => import('@/views/CloundMonitor/deviceManagement/projectGroup/index'),
                        meta: { title: '项目列表', sonId: 214, requiresAuth: true }
                    },
                    {
                        path: 'deviceList',
                        name: 'CloudMonitorDeviceList',
                        component: () => import('@/views/CloundMonitor/deviceManagement/deviceList/index'),
                        meta: { title: '设备列表', sonId: 215, requiresAuth: true, keepAlive: true }
                    },
                    {
                        path: 'terminalList',
                        name: 'CloudMonitorTerminalList',
                        component: () => import('@/views/CloundMonitor/deviceManagement/terminalList/index'),
                        meta: { title: '终端列表', sonId: 216, requiresAuth: true, keepAlive: true }
                    },
                    {
                        path: 'collectConfigurate',
                        name: 'CollectConfigurate',
                        component: () => import('@/views/CloundMonitor/deviceManagement/collectConfigurate/index'),
                        meta: { title: '采集配置', sonId: 217, requiresAuth: true },
                    },
                    {
                        path: 'variableList',
                        name: 'variableList',
                        component: () => import('@/views/CloundMonitor/deviceManagement/variableList/index'),
                        meta: { title: "变量列表", sonId: 217, requiresAuth: true }
                    }
                    // {
                    //   path: 'editCollection',
                    //   name: 'EditCollection',
                    //   component: () => import('@/views/CloundMonitor/deviceManagement/collectConfigurate/components/editCollection'),
                    //   meta: { title: '添加变量', requiresAuth: true}
                    // }
                ]
            },
            // 报警管理
            {
                path: 'alarmManagement',
                meta: { title: '报警管理', requiresAuth: true },
                component: contList,
                children: [
                    {
                        path: 'alarmNotice',
                        name: 'AlarmNotice',
                        component: () => import('@/views/CloundMonitor/alarmManagement/alarmNotice/index'),
                        meta: { title: '报警通知', sonId: 218, requiresAuth: true }
                    },
                    {
                        path: 'alarmContact',
                        name: 'AlarmContact',
                        component: () => import('@/views/CloundMonitor/alarmManagement/alarmContact/index'),
                        meta: { title: '报警联系人', sonId: 219, requiresAuth: true }
                    },
                    {
                        path: 'alarmList',
                        name: 'AlarmList',
                        component: () => import('@/views/CloundMonitor/alarmManagement/alarmList/index'),
                        meta: { title: '报警记录', sonId: 264, requiresAuth: true }
                    },
                ]
            },
            // 统计报表
            {
                path: 'statisticalReports',
                meta: { title: '统计报表', requiresAuth: true },
                component: contList,
                children: [
                    {
                        path: 'historyRecords',
                        name: 'HistoryRecords',
                        component: () => import('@/views/CloundMonitor/statisticalReports/historyRecords/index'),
                        meta: { title: '历史记录', sonId: 220, requiresAuth: true }
                    },
                    {
                        path: 'devicesStatus',
                        name: 'DevicesStatus',
                        component: () => import('@/views/CloundMonitor/statisticalReports/devicesStatus/index'),
                        meta: { title: '设备上下线', requiresAuth: true }
                    },
                ]

            }
            ]
        },
    ]
})
router.beforeEach((to, from, next) => {
    //获取菜单权限
    const Menu = getMenu()
    //获取Token
    const Token = getToken()
    //获取当前登录的id
    const user_iscustomer = getuser_iscustomer()
    const user_ctid = getuser_ctid()
    //获取每页的权限
    const Permission = getPermission()
    // console.log(extractValues(Menu,'sonId'))
    //如果当前进入的页面与菜单权限与路由保存的菜单权限sonId不一致跳转404
    if (to.meta.sonId) {
        if (Menu) {
            if (Menu.indexOf(to.meta.sonId) != -1) {
                next()
            } else {
                return next('/404')
            }
        }
    }
    //如果当前进入的url不是登录页面，并且没有token重定向登录
    if (to.meta.requiresAuth) {

        if (to.path !== '/login' && !Token) {
            return next('/login')
        }
    }

    if (to.meta.keepAlive) {
        // store.dispatch('addKeepAlive',to.name)
        // 先判断是否已经缓存
        if (!store.state.keepAlive.includes.includes(to.name)) {
            store.dispatch('addKeepAlive', to.name)
        }
    }

    //如果当前跳转至登录页面token存在重定向至首页
    if (to.path == '/login') {
        removeToken()
        removeMenu()
        removePermission()
        let language = window.localStorage.getItem('I18n')
        window.localStorage.clear()
        if (language == 'en-US') {
            window.localStorage.setItem('I18n', 'en-US')
        } else if (language == "zh-TW") {
            window.localStorage.setItem('I18n', 'zh-TW')
        } else {
            window.localStorage.setItem('I18n', 'zh-CN')
        }
    }
    //远程操作与设备详情需要用户权限才能进入
    if (to.meta.Permission) {
        if (Permission) {
            if (Permission.indexOf(to.meta.Permission) != -1) {
                next()
            } else {
                return next('/404')
            }
        }
    }
    next()
})

export default router
